.signet-modal {
  .signet-overlay {
    padding: 16px;

    .content {
      display: flex;
      justify-content: center;
      transform: scale(0.95);
      margin-top: -20vh;
      padding-top: 20px;
      box-lines: none;

      .modal-wrapper {
        width: 100%;
        max-height: 80vh;
        overflow-y: auto;
        background-color: white;
        padding: 16px;
        transition: all 0.3s ease-in-out;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        margin: 0 !important;

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-content: flex-start;
          align-items: center;
          margin-bottom: 12px;

          .modal-title {
            line-height: 1;
            color: var(--text-primary);
          }

          .modal-close {
            cursor: pointer;

            .text {
              padding: 0;

              .icon {
                font-size: 24px;
                color: var(--text-primary);
              }
            }
          }
        }

        .modal-content {
          .modal-footer {
            display: flex;
            justify-content: flex-end;
            margin-top: 12px;
          }
        }
      }
    }

    &.opened {
      .content {
        transform: scale(1);

        .modal-wrapper {
          transition: all 0.3s ease-in-out;
        }
      }
    }
  }
}
